import { memo, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { I18nKey } from '../../../i18n/i18n.key';
import { useTheme } from '../../../themes/theme.provider';
import { useApp } from '../../../hook/app.hook';
import { secondsToHMS } from '../../../util/timer.util';

interface SaveStatusComponentProps {
  className?: string;
  showIcon?: boolean;
  fontSize?: string;
}

const SaveStatusComponent = ({
  className = '',
  showIcon = true,
  fontSize = '',
}: SaveStatusComponentProps) => {
  const { t } = useTranslation();
  const { themeType, theme } = useTheme();
  const { lastSaveTime } = useApp();

  const [lastSaveDiff, setLastSaveDiff] = useState(0);

  const updateResIntervalId = useRef<any>(null);

  const startSaveRes = () => {
    if (updateResIntervalId.current) {
      clearInterval(updateResIntervalId.current);
    }
    updateResIntervalId.current = setInterval(() => {
      const _lastSaveDiff = (new Date().getTime() - lastSaveTime) / 1000;
      setLastSaveDiff(_lastSaveDiff);
    }, 4000);
  };

  useEffect(() => {
    startSaveRes();
    return () => {
      if (updateResIntervalId.current) {
        clearInterval(updateResIntervalId.current);
      }
    };
  }, [lastSaveTime]);

  return (
    <div style={{ color: theme.themewhite, fontSize }} className={className}>
      {showIcon && (
        <img
          src={`/images/${
            themeType === 'light' ? 'cloud-dark.svg' : 'cloud.svg'
          }`}
          alt=""
        />
      )}
      <span className={showIcon ? 'mx-2' : ''}>
        {t(I18nKey.SAVED_TEXT)}:{' '}
        <b style={{ color: theme.themewhite }} className="me-1">
          {secondsToHMS(lastSaveDiff)}
        </b>
        {t(I18nKey.AGO_TEXT)}
      </span>
    </div>
  );
};

export default memo(SaveStatusComponent);
